import axios from 'axios';

export default function TabSettings(props) {

  function logout(formData){
    axios.post(process.env.REACT_APP_BASE_URL+'auth/logout',null,{headers:{'SessionKey':props.sessionKey}})
      .then(response => {
        localStorage.removeItem('sessionKey');
        localStorage.removeItem('tourData');
        localStorage.removeItem('sessionUser');
        props.onSetSessionKey(null);
        props.onSetSessionUser(null);
      });
  }

  return (
    <div>
      <h3 className="ui inverted block header">Settings</h3>
      <div className="ui segment">
        <form className="ui large form" action={logout}>
          <div className="field">
            <div className="ui left icon">
              <i className="user icon"></i>
              {props.sessionUser.firstName} {props.sessionUser.lastName} 
            </div>
          </div>
          <div className="field">
            <div className="ui left icon">
              <i className="envelope icon"></i>
              {props.sessionUser.email}
            </div>
          </div>
          <button type="submit" className="ui fluid large primary submit button">Logout</button>
        </form>
      </div>

    {
            props.unsentItems>0 ? 
            <div className="ui segment">
              <a href="#" class="ui link" onClick={props.serviceQueueSend}><i className="envelope open outline icon"></i> {props.unsentItems} Aktionen noch nicht versendet</a><br />
              Sobald Sie online sind, versuchen Sie diese zu versenden indem Sie auf den Link klicken.
            </div>
            : ''
          }

    </div>
  );
}